// src/state/dmUiStore.js
import { create } from 'zustand';

const MIN_SIDEBAR_WIDTH = 220;  // px
const MAX_SIDEBAR_WIDTH = 600;  // px;
const DEFAULT_SIDEBAR_WIDTH = 320;

export const useDmUiStore = create((set, get) => ({
  // Array of DM threads. We'll define the exact shape later, but at
  // minimum each record will include: dmKey, peerUid, state, matrixRoomId.
  dmList: [],

  // The currently selected DM key (string) or null.
  selectedDmKey: null,

  // Sidebar width in pixels (for the resizable divider).
  sidebarWidth: DEFAULT_SIDEBAR_WIDTH,

  // ----- Actions -----

  // Set the currently selected DM by key
  setSelectedDm: (dmKey) => {
    set({ selectedDmKey: dmKey });
  },

  // Update or insert a DM thread snapshot
  upsertDm: (dm) => {
    const { dmList } = get();
    const idx = dmList.findIndex((t) => t.dmKey === dm.dmKey);
    if (idx === -1) {
      set({ dmList: [...dmList, dm] });
    } else {
      const next = dmList.slice();
      next[idx] = { ...next[idx], ...dm };
      set({ dmList: next });
    }
  },

  // Replace the entire DM list from server or a snapshot
  setDmList: (dmList) => set({ dmList }),

  // Adjust the sidebar width (with clamping)
  setSidebarWidth: (px) => {
    const clamped = Math.max(
      MIN_SIDEBAR_WIDTH,
      Math.min(MAX_SIDEBAR_WIDTH, px)
    );
    set({ sidebarWidth: clamped });
  },

  // Reset everything (e.g., on logout)
  resetDmUi: () =>
    set({
      dmList: [],
      selectedDmKey: null,
      sidebarWidth: DEFAULT_SIDEBAR_WIDTH,
    }),
}));
